function readProcessEnv(key: string): string | undefined {
    if (typeof process === 'undefined' || !process.env) {
        return undefined;
    }

    return process.env[key];
}

const LOCAL_DEVELOPMENT_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '[::1]']);

export function isLocalDevelopmentHostname(hostname: string | undefined): boolean {
    if (!hostname) {
        return false;
    }

    return (
        LOCAL_DEVELOPMENT_HOSTNAMES.has(hostname) ||
        hostname.endsWith('.localhost') ||
        hostname.endsWith('.local')
    );
}

export function isDevelopmentRuntime(): boolean {
    return (
        readProcessEnv('NODE_ENV') === 'development' ||
        (typeof window !== 'undefined' && isLocalDevelopmentHostname(window.location.hostname))
    );
}

export function isStagingRuntime(): boolean {
    return readProcessEnv('NEXT_PUBLIC_USE_STAGING') === 'true';
}

export function getDefaultLocaleEnv(): string | undefined {
    return readProcessEnv('DEFAULT_LOCALE');
}
